import { CONFIG } from './config.js';
import { dom } from './dom.js';
import { state } from './state.js';
import { UI } from './ui.js';
import { Search } from './search.js';
import { Actions } from './actions.js';
import { Parser } from './parser.js';

export const Events = {
  onDocumentClick(event) {
    const actionTarget = event.target.closest('[data-action]');

    if (!actionTarget) {
      if (!event.target.closest('.dropdown')) UI.closeDropdowns();
      return;
    }

    const { action } = actionTarget.dataset;

    switch (action) {
      case 'toggle-dropdown': {
        const dropdown = document.getElementById(actionTarget.dataset.target);
        const isOpen = dropdown?.classList.contains('open');
        UI.closeDropdowns();
        if (!isOpen) UI.openDropdown(actionTarget.dataset.target);
        break;
      }
      case 'load-sample':
        Actions.loadSample(actionTarget.dataset.sample);
        break;
      case 'set-layout':
        Actions.setLayout(actionTarget.dataset.layout);
        break;
      case 'toggle-option':
        Actions.toggleOption(actionTarget.dataset.option);
        break;
      case 'set-theme':
        Actions.setTheme(actionTarget.dataset.theme);
        break;
      case 'parse':
        Parser.parse();
        break;
      case 'eval':
        Parser.evalInput();
        break;
      case 'format':
        Parser.format();
        break;
      case 'minify':
        Parser.minify();
        break;
      case 'copy':
        Actions.copyOutput();
        break;
      case 'clear':
        Actions.clear();
        break;
      case 'toggle-node': {
        const container = actionTarget.closest('.node-container');
        if (!container) return;
        container.classList.toggle('collapsed');
        actionTarget.textContent = container.classList.contains('collapsed') ? '▸' : '▾';
        break;
      }
      default:
        break;
    }
  },

  onInputChange() {
    window.clearTimeout(state.debounceTimer);
    state.debounceTimer = window.setTimeout(() => Parser.parse(), CONFIG.autoParseDelay);
  },

  onKeyDown(event) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
      event.preventDefault();
      Parser.parse();
    }

    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key.toLowerCase() === 'f') {
      event.preventDefault();
      Parser.format();
    }

    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key.toLowerCase() === 'm') {
      event.preventDefault();
      Parser.minify();
    }

    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      dom.searchInput.focus();
    }

    if (event.key === 'Escape') {
      UI.closeDropdowns();
    }
  },

  bind() {
    document.addEventListener('click', Events.onDocumentClick);
    document.addEventListener('keydown', Events.onKeyDown);
    dom.inputArea.addEventListener('input', Events.onInputChange);
    dom.searchInput.addEventListener('input', Search.apply);

    // Double-click on input area selects all content
    dom.inputArea.addEventListener('dblclick', () => {
      dom.inputArea.select();
    });

    // Hamburger menu (mobile)
    const hamburger = document.getElementById('hamburger');
    const headerControls = document.getElementById('header-controls');
    if (hamburger && headerControls) {
      hamburger.addEventListener('click', () => {
        const isOpen = headerControls.classList.toggle('open');
        hamburger.classList.toggle('open', isOpen);
        hamburger.setAttribute('aria-expanded', String(isOpen));
      });
    }

    // Touch support for divider drag
    dom.divider.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      dom.divider.dispatchEvent(new MouseEvent('mousedown', { clientX: touch.clientX, clientY: touch.clientY }));
      e.preventDefault();
    }, { passive: false });

    document.addEventListener('touchmove', (e) => {
      const touch = e.touches[0];
      document.dispatchEvent(new MouseEvent('mousemove', { clientX: touch.clientX, clientY: touch.clientY }));
    }, { passive: true });

    document.addEventListener('touchend', () => {
      document.dispatchEvent(new MouseEvent('mouseup'));
    });

    // Force top-bottom layout on mobile
    const mobileQuery = window.matchMedia('(max-width: 640px)');
    const applyMobileLayout = (e) => { if (e.matches) dom.workspace.classList.add('top-bottom'); };
    applyMobileLayout(mobileQuery);
    mobileQuery.addEventListener('change', applyMobileLayout);
  },
};
